module.exports = __webpack_public_path__ + "static/media/T4.d8971ecc.jpg";